<template>
  <account-container title="Change password">
    <div class="form-group">
      <label for="username">Username / Email</label>
      <input type="text" 
            id="username" 
            fieldlabel="Username"
            v-model="username"
            v-taurus-validator="'required'"
            class="form-control form-control-lg">
      <div class="" name="username" invalidfeedback="Please enter username / email address"></div>
    </div>
    <div class="form-group">
      <label for="password">Existing password</label>
      <input type="text" 
            id="password" 
            fieldlabel="Password"
            v-model="password"
            v-taurus-validator="'required'"
            class="form-control form-control-lg">
      <div class="" name="password" invalidfeedback="Please enter your password"></div>
    </div>
    <div class="form-group">
      <label for="newPassword">New password</label>
      <input type="text" 
            id="password" 
            fieldlabel="New password"
            v-model="newPassword"
            v-taurus-validator="'required'"
            class="form-control form-control-lg">
      <div class="" name="newPassword" invalidfeedback="Please enter a new password"></div>
    </div>
    <button class="button" @click="handleSubmit()">Change password</button>
  </account-container>
  
  <!-- <div class="greybox"><h1>Change password</h1>
        <label for="username">Username / Email</label>
        <input type="text" class="reviewInputs"  id="username" name="username" placeholder="" v-model="username">
        <div
            v-if="submitted && !username"
            class="text-danger">
            <small>Please enter your username / email address</small>
        </div>
        <label for="password">Existing password</label>
        <input type="password" id="password" name="password" placeholder="" v-model="password">
        <div
            v-if="submitted && !password"
            class="text-danger">
            <small>Please enter your password</small>
        </div>
        <label for="newPassword">New password</label>
        <input type="password" id="newPassword" name="newPassword" placeholder="" v-model="newPassword">
        <div
            v-if="submitted && !newPassword"
            class="text-danger">
            <small>Please enter a new password</small>
        </div>
        <button class="button" @click="handleSubmit()">Change password</button>
    </div> -->
</template>

<script>

import base from '@/mixins/base'
import AccountContainer from '@/components/AccountContainer.vue'
export default {
  name: 'login',
  mixins: [
    base
  ],
  components: {
    AccountContainer,
  },
  data () {
    return {
      username: '',
      password: '',
      newPassword: '',
      submitted: false
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.authentication.status.loggingIn
    }
  },
  created () {

  },
  methods: {
    handleSubmit (e) {
      this.submitted = true
      const { resellerId, username, newPassword, password } = this
      const { dispatch } = this.$store
      if (username && newPassword && password) {
        dispatch('authentication/changePassword', { resellerId, username, newPassword, password })
      }
    }
  }
}
</script>
